// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { CreatedBy } from "./CreatedBy";
import {
  CreatedByFromJSON,
  CreatedByFromJSONTyped,
  CreatedByToJSON,
  CreatedByToJSONTyped,
} from "./CreatedBy";
import type { TenantRole } from "./TenantRole";
import {
  TenantRoleFromJSON,
  TenantRoleFromJSONTyped,
  TenantRoleToJSON,
  TenantRoleToJSONTyped,
} from "./TenantRole";
import type { ProjectRole } from "./ProjectRole";
import {
  ProjectRoleFromJSON,
  ProjectRoleFromJSONTyped,
  ProjectRoleToJSON,
  ProjectRoleToJSONTyped,
} from "./ProjectRole";

/**
 *
 * @export
 * @interface InvitationRead
 */
export interface InvitationRead {
  /**
   *
   */
  id: string;
  /**
   *
   */
  createdBy: CreatedBy;
  /**
   *
   */
  email: string;
  /**
   *
   */
  status: string;
  /**
   *
   */
  tenant: string;
  /**
   *
   */
  tenantRole: TenantRole;
  /**
   *
   */
  project?: string | null;
  /**
   *
   */
  projectRole?: ProjectRole | null;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  expiresAt: Date;
}

/**
 * Check if a given object implements the InvitationRead interface.
 */
export function instanceOfInvitationRead(value: object): value is InvitationRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdBy" in (value as Record<string, any>)) &&
      !("created_by" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdBy"] === undefined &&
      (value as Record<string, any>)["created_by"] === undefined)
  )
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("tenant" in value) || value["tenant"] === undefined) return false;
  if (
    (!("tenantRole" in (value as Record<string, any>)) &&
      !("tenant_role" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["tenantRole"] === undefined &&
      (value as Record<string, any>)["tenant_role"] === undefined)
  )
    return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (
    (!("expiresAt" in (value as Record<string, any>)) &&
      !("expires_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["expiresAt"] === undefined &&
      (value as Record<string, any>)["expires_at"] === undefined)
  )
    return false;
  return true;
}

export function InvitationReadFromJSON(json: any): InvitationRead {
  return InvitationReadFromJSONTyped(json, false);
}

export function InvitationReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InvitationRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdBy: CreatedByFromJSON(json["created_by"]),
    email: json["email"],
    status: json["status"],
    tenant: json["tenant"],
    tenantRole: TenantRoleFromJSON(json["tenant_role"]),
    project:
      json["project"] === undefined ? undefined : json["project"] === null ? null : json["project"],
    projectRole:
      json["project_role"] === undefined
        ? undefined
        : json["project_role"] === null
        ? null
        : ProjectRoleFromJSON(json["project_role"]),
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    expiresAt: json["expires_at"] == null ? json["expires_at"] : parseDateTime(json["expires_at"]),
  };
}

export function InvitationReadToJSON(json: any): InvitationRead {
  return InvitationReadToJSONTyped(json, false);
}

export function InvitationReadToJSONTyped(
  value?: InvitationRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_by: CreatedByToJSON(value["createdBy"]),
    email: value["email"],
    status: value["status"],
    tenant: value["tenant"],
    tenant_role: TenantRoleToJSON(value["tenantRole"]),
    project: value["project"],
    project_role: ProjectRoleToJSON(value["projectRole"]),
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    expires_at:
      value["expiresAt"] == null ? value["expiresAt"] : serializeDateTime(value["expiresAt"]),
  };
}
